<template>
  <div data-spm="feed" ref="commendFeedRef">
    <!-- 置顶文章 -->
    <div id="topFeed" v-if="topList.length">
        <div class="feed-header">
            <span class="feed-header__title">置顶文章</span>
            <hr class="fake-hr" />
        </div>
        <div class="feed-content" data-solt="topFeedContent">
            <template v-for="(item,index) in topList">
                <TripleImgs :key="index" :feedData="item" v-if="item.type==3"/>
                <SimgleImg :key="index" :feedData="item" v-else-if="item.images && item.images.length > 0" />
                <NoImg :key="index" :feedData="item" v-else/>
            </template>
        </div>
    </div>
    <!-- 最新文章 -->
    <div id="recentFeed">
        <div class="feed-header">
            <span class="feed-header__title">最新文章</span>
            <hr class="fake-hr" />
        </div>
        <div class="feed-content">
            <div data-solt="recentFeedContent">
                <template v-for="(item,index) in list">
                    <TripleImgs :key="index" :feedData="item" v-if="item.type==3"/>
                    <SimgleImg :key="index" :feedData="item" v-else-if="item.images && item.images.length > 0" />
                    <NoImg :key="index" :feedData="item" v-else/>
                </template>
            </div>
            <!-- 列表的状态 -->
            <div class="list-status">
                <div data-role="empty" class="more-load" v-if="isFinish">已经到底了</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import NoImg from './no-img.vue'
import SimgleImg from './simgle-img.vue'
import TripleImgs from './triple-imgs.vue'
import axios from 'axios'
import Str from "@/utils/string"
import Moment from "@/utils/moment"
import spmUtils from "@/utils/spm_utils"
import { setPicSize } from "@/utils/pic-util"
import Util from "@/_utils/util"

export default {
  name: "",
  components:{
    NoImg,
    SimgleImg,
    TripleImgs
  },
  data() {
    return {
        size: 15,
        page: 1,
        list: [],
        topList: [], // 置顶文章
        isLoading: false,
        isFinish: false
    };
  },
  mounted() {
    this.getData()
    window.addEventListener('scroll', Util.throttle(this.handleScroll, 50), true)
  },
  methods: {
    getData() {
        if(this.isLoading)return
        if(this.isFinish)return
        this.isLoading = true
        const url = '//v2.sohu.com/article-service-api/collection/articles/'+ window.pcArticleInfo?.id
        const p = {
            pno: this.page++,
            pSize: this.size
        }
        axios.get(url,{ params: p }).then(res=>{
            const data = res.data
            const list = data.data
            if(data.code == 200 && list?.length) {
                list.forEach((item)=>{
                    const formatItem = this.formatData(item)
                    if(this.page == 2 && item.priority == 1) {
                        this.topList.push(formatItem)
                    }else {
                        this.list.push(formatItem)
                    }
                })
                if(list.length < this.size) { 
                    this.isFinish = true
                }
            }else {
                this.isFinish = true
            }
        }).catch (()=>{
            this.isFinish = true
        }).finally(()=>{
            this.isLoading = false
            window.LazyLoad?.scanImg();
            this.$nextTick(()=>{
                sohuSpm?.domDidChange({target:'feed'})
            })
        })
    },
    formatData (item) {
        // 处理时间
        item.publicTime && (item.fixTime = new Moment(item.publicTime).fixTime())
        item.brief = item.brief || '';
        item?.images?.forEach(img => {
            if(item.type == 3) {
                const coverWidth = index === 0 ? 249 * 2 : 124 *2
                const coverHeight = index === 0 ? 165 *2 : 82 * 2
                img = setPicSize(img, coverWidth, coverHeight)
            }else {
                img = setPicSize(img, 190 * 2, 126 * 2)
            }
        })
        return item
    },
    handleScroll() {
        if (this.isLoading)return
        if (this.isFinish)return
        const windowHeight = window.innerHeight
        const dom = this.$refs['commendFeedRef']
        const listToTop = dom.getBoundingClientRect().bottom
        if (listToTop <= windowHeight + 200) {
            this.getData()
        }
    }
    
  },
 
};
</script>
<style lang="less" scoped>

</style>